import {getTimeZone} from "_helpers";
import * as moment from 'moment-timezone';
import {channelTypes} from "_constants";

export const proactiveCriteriaOptions = {
    retain: [
        { "name": "all_messages", "value": "All messages" },
        { "name": "replied", "value": "Replied" },
        { "name": "converted", "value": "Converted" },
        { "name": "followUpSent", "value": "Follow Up Sent" },
        { "name": "convertedAfterFollowUpSent", "value": "Converted After Follow Up" },
        { "name": "hasAdditionalOrders", value: "Has Additional Orders" }
    ],
    acquire: [
        { "name": "all_messages", "value": "All messages" },
        { "name": "replied", "value": "Replied" },
        { "name": "liked", "value": "Liked" },
        { "name": "noEngagementYet", "value": "No Engagement Yet" },
        { "name": "followed", "value": "Followed" }
    ]
};

export const proactiveAttributionCriteriaOptions = {
    retain: [
        { "name": "orderedWithin5Days", value: "Ordered Within 5 Days" },
        { "name": "orderedRecommendedCategory", value: "Ordered Recommended Category" },
        { "name": "orderedRecommendedProduct", value: "Ordered Recommended Product" },
        { "name": "usedDiscount", value: "Used Discount" },
        { "name": "usedExactDiscountCode", value: "Used Exact Discount Code" },
        { "name": "lastTouch", value: "Last Touch" }
    ]
};

export function formatDateCreated(date, format) {
    const timezone = getTimeZone();
    return `${moment.tz(date, timezone).format(format)}`
}

export const isShopifyAndFirstIncomingMessage = (messageSource, isFirstIncomingMessaging) => {
    const isSourceShopify = messageSource?.toUpperCase() === channelTypes.shopify
    return isSourceShopify && isFirstIncomingMessaging
}

const ATTRIBUTION_CRITERIA_RULES = [
    {
        matcher: (h) =>
            !h.orderedRecommendedProduct &&
            !h.usedExactDiscountCode &&
            !h.orderedRecommendedCategory &&
            !h.orderedWithin5d,
        message: () => ''
    },
    {
        matcher: (h) => h.orderedRecommendedCategory && h.usedExactDiscountCode,
        message: () => 'Customer ordered the recommended category and used the exact discount code'
    },
    {
        matcher: (h) =>
            h.usedExactDiscountCode && !h.orderedRecommendedProduct && !h.orderedRecommendedCategory,
        message: () => 'Customer used the exact discount code'
    },
    {
        matcher: (h) => h.orderedRecommendedProduct && h.lastTouch,
        message: () =>
            'Customer ordered the recommended product and Remarkable AI email was the last touch before their order'
    },
    {
        matcher: (h) => h.orderedRecommendedCategory && h.lastTouch && !h.orderedRecommendedProduct,
        message: () =>
            'Customer ordered the recommended category and Remarkable AI email was the last touch before their order'
    },
    {
        matcher: (h) => h.orderedRecommendedProduct && h.orderedWithin5d && !h.lastTouch,
        message: (h) => `Customer ordered the recommended product within ${h.orderedWithin5dDays} days of the email`
    },
    {
        matcher: (h) => h.orderedRecommendedProduct && !h.orderedWithin5d && !h.lastTouch,
        message: () => 'Customer ordered the recommended product'
    },
    {
        matcher: (h) =>
            h.orderedRecommendedCategory &&
            h.orderedRecommendedProduct &&
            !h.orderedWithin5d &&
            !h.lastTouch,
        message: () => 'Customer ordered the recommended product'
    },
    {
        matcher: (h) =>
            h.orderedRecommendedCategory &&
            h.orderedWithin5d &&
            !h.orderedRecommendedProduct &&
            !h.lastTouch,
        message: (h) => `Customer ordered the recommended category within ${h.orderedWithin5dDays} days of the email`
    },
    {
        matcher: (h) =>
            h.orderedRecommendedCategory &&
            !h.orderedWithin5d &&
            !h.lastTouch &&
            !h.orderedRecommendedProduct,
        message: () => 'Customer ordered the recommended category'
    },
    {
        matcher: (h) =>
            h.orderedWithin5d &&
            !h.orderedRecommendedProduct &&
            !h.orderedRecommendedCategory &&
            !h.lastTouch,
        message: (h) => h.orderedWithin5dDays === 0 ?
            `Customer ordered the same day after the email was sent` :
            `Customer ordered within ${h.orderedWithin5dDays} days of the email`
    },
    {
        matcher: (h) =>
            h.orderedWithin5d &&
            h.lastTouch &&
            !h.orderedRecommendedProduct &&
            !h.orderedRecommendedCategory,
        message: () => 'Remarkable AI email was the last touch before their order'
    },
    {
        matcher: (h) =>
            h.lastTouch &&
            !h.orderedRecommendedProduct &&
            !h.orderedRecommendedCategory &&
            !h.orderedWithin5d,
        message: () => 'Remarkable AI email was the last touch before their order'
    }
];

export function getAttributionMessage(attributions) {
    const matchingRule = ATTRIBUTION_CRITERIA_RULES.find((rule) => rule.matcher(attributions));

    if (matchingRule) {
        return matchingRule.message(attributions);
    }
    return null;
}